import { __awaiter, __extends, __generator } from "tslib";
import { AbstractDocumentDataUpdater } from '../../document-data/document-data-updater';
var BaseDocumentDataUpdater = /** @class */ (function (_super) {
    __extends(BaseDocumentDataUpdater, _super);
    function BaseDocumentDataUpdater() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BaseDocumentDataUpdater.prototype, "buildDocumentEntities", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return [];
        }
    });
    Object.defineProperty(BaseDocumentDataUpdater.prototype, "getImageUrls", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (response, param) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, []];
                });
            });
        }
    });
    return BaseDocumentDataUpdater;
}(AbstractDocumentDataUpdater));
export { BaseDocumentDataUpdater };
